import { login, logout, getInfo,listcateall } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { register } from '../../api/login'
import { asyncRouterMap } from '@/router/index';
import { stringToBase64AES } from '@/utils/help'

const user = {
  state: {
    token: getToken(),
    name: '',
    phone:'',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {  
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, stringToBase64AES(userInfo.password),userInfo.code,userInfo.sid).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 注册
    Register({ commit }, userInfo) {  
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        register(username, stringToBase64AES(userInfo.password),userInfo.regcode).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          commit('SET_ROLES', asyncRouterMap)
          commit('SET_NAME', data.nickname)
          commit('SET_PHONE',data.phone)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js